import styled from './sucessosenha.module.css';
import { useNavigate } from 'react-router-dom';

function SucessoSenha() {
    const Navigate = useNavigate();
    function Login(){
        Navigate('/')
    }
    
    
    return (
        <div className={styled.page}>
            <div className={styled.container}>
                <div className={styled.logo}>
                    <div className={styled.logoimg}></div>
                </div>
                <div className={styled.card}>
                   <div className={styled.cardcontent}>
                       <div className={styled.app}>
                          <div className={styled.frame101}></div>
                          <a>Sua senha foi criada com sucesso</a>
                          <div onClick={()=>Login()} className={styled.btn}>IR PARA LOGIN</div>
                       </div>
                   </div>
                </div>
            </div>
        </div>
    )
}


export default SucessoSenha;